import styled, { css } from 'styled-components';

import { H2, H4styles } from '~/src/common/components/Typography';
import CatalogContentScreenLayout from '~/src/screens/CatalogContent/ContentScreen/CatalogContentScreenLayout';
import ProductImageSlider from '~/src/screens/CatalogContent/ContentScreen/ImageSlider/ImageSlider';
import { ThumbnailsContainer } from '~/src/screens/CatalogContent/ContentScreen/ImageSlider/layout';
import { ProductGridArea } from '~/src/screens/CatalogContent/ContentScreen/ProductScreen/constants';
import {
  Key,
  Value,
} from '~/src/screens/CatalogContent/ContentScreen/ProductScreen/ProductAdditionalInformation/layout';
import { Header as ProductInfoHeader } from '~/src/screens/CatalogContent/ContentScreen/ProductScreen/ProductGenericInformation/layout';
import { ProductPriceAndPick } from '~/src/screens/CatalogContent/ContentScreen/ProductScreen/ProductHeaderPane/ProductPriceAndPick/ProductPriceAndPick';
import { ProductPrimaryInformation } from '~/src/screens/CatalogContent/ContentScreen/ProductScreen/ProductHeaderPane/ProductPrimaryInformation/ProductPrimaryInformation';
import { ProductSecondaryInformation } from '~/src/screens/CatalogContent/ContentScreen/ProductScreen/ProductHeaderPane/ProductSecondaryInformation/ProductSecondaryInformation';
import { ProductShortDescription } from '~/src/screens/CatalogContent/ContentScreen/ProductScreen/ProductHeaderPane/ProductShortDescription/ProductShortDescription';
import { ProductXSell } from '~/src/screens/CatalogContent/ContentScreen/ProductScreen/ProductXSell/ProductXSell';
import { media } from '~/src/styles-constants';

import * as S from '../layout';

import ProductAdditionalInformation from './ProductAdditionalInformation';

/* TODO: Move overrides for display none to components style instead of overriding it here once 'configuration-page-produit' is cleaned  */
export const Content = styled(CatalogContentScreenLayout)`
  ${S.NavigationContainer} {
    display: flex;
    padding: 24px 0 0;
    margin-bottom: -8px; /* It is the only item in the grid that has a gap of 16px instead of 24px; */

    & > button > div > span:first-child {
      margin-left: 0;
      margin-right: 0;
    }
  }

  ${S.BreadcrumbsContainer} {
    display: flex;
  }

  /* A changer en h4 une fois le flag supprime */
  ${ProductInfoHeader} {
    ${H4styles}
  }

  ${media.M`
    margin-top: auto;

    ${S.NavigationContainer} {
      display: flex;
      padding-top: 8px;
    }
  `}
`;

export const Layout = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-row-gap: 24px;

  grid-template-areas:
    '${ProductGridArea.Breadcrumbs}'
    '${ProductGridArea.PrimaryInfos}'
    '${ProductGridArea.Gallery}'
    '${ProductGridArea.SecondaryInfos}'
    '${ProductGridArea.ShortDescription}'
    '${ProductGridArea.Picker}';

  ${media.M`
    grid-template-columns: 1fr 450px;
    grid-row-gap: 16px;
    grid-column-gap: 40px;

    grid-template-areas: 
    "${ProductGridArea.Breadcrumbs} ${ProductGridArea.Breadcrumbs}"
    "${ProductGridArea.Gallery} ${ProductGridArea.PrimaryInfos}"
    "${ProductGridArea.Gallery} ${ProductGridArea.Picker}"
    "${ProductGridArea.Gallery} ${ProductGridArea.SecondaryInfos}"
    "${ProductGridArea.Gallery} ${ProductGridArea.ShortDescription}"
  `}
`;

const AsideBlock = css`
  padding-left: 16px;
  padding-right: 16px;

  ${media.M`
    padding: 16px 0 0;
    border-top: ${({ theme }) => `1px solid ${theme.palette.common.BACKGROUND_3}`};
  `}
`;

export const PrimaryInformation = styled(ProductPrimaryInformation)`
  grid-area: ${ProductGridArea.PrimaryInfos};
  padding: 0 16px;

  ${media.M`
    padding: 0;
  `}
`;

export const ImageSlider = styled(ProductImageSlider)`
  grid-area: ${ProductGridArea.Gallery};

  ${ThumbnailsContainer} {
    padding-left: 16px;
  }

  ${media.M`
    padding: 0;

    ${ThumbnailsContainer} {
      padding-left: 0px;
    }
  `}
`;

export const Picker = styled(ProductPriceAndPick)`
  grid-area: ${ProductGridArea.Picker};
  ${AsideBlock}
`;

export const SecondaryInformation = styled(ProductSecondaryInformation)`
  grid-area: ${ProductGridArea.SecondaryInfos};
  ${AsideBlock}
`;

export const ShortDescription = styled(ProductShortDescription)`
  grid-area: ${ProductGridArea.ShortDescription};
  ${AsideBlock}
`;

export const XSell = styled(ProductXSell)`
  padding: 0 16px;

  ${media.M`
    padding: 0;
  `}
`;

/* TODO: Doit etre applique dans le composant ProductAdditionalInformation lui meme apres suppression du FF configuration-page-produit */
export const AdditionalInformation = styled(ProductAdditionalInformation)`
  padding-bottom: 56px;
  & ${Key}, & ${Value} {
    font-size: 14px;
  }

  /* A changer en h4 une fois le flag supprime */
  & ${H2} {
    ${H4styles};
    margin-top: 0;
  }

  ${media.M`
    width: calc(100% - 450px);
  `}
`;
